<script>
export default {
    name: "InsuranceDetailsTab",

    props: {
        patientInsurances: Array,
    },
}
</script>
<template>
    <div class="md:w-3/4 sm:w-full overflow-auto mt-1">
        <table class="table table-hover">
            <thead class="bg-blue-500 text-sm text-white whitespace-no-wrap">
                <tr class="w-full flex">
                    <th class="p-tiny w-1/3">Insurance</th>
                    <th class="p-tiny w-1/3">Principal Info</th>
                    <th class="p-tiny w-1/3">Dependant Info</th>
                </tr>
            </thead>
            <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:25vh;">
                <tr v-for="(patientInsurance, idx) in patientInsurances" :key="idx" class="flex w-full">
                    <td class="p-tiny w-1/3">{{ patientInsurance.organization }}</td>
                    <td class="p-tiny w-1/3">
                        <h5 class="font-bold text-sm">Member No: {{ patientInsurance.memberno }}</h5>
                        <h5 class="font-bold text-xs text-gray-700">ID NO: {{ patientInsurance.memberIDNo }}</h5>
                        <h5 class="font-bold text-xs text-gray-700">Employer: {{ patientInsurance.employer }}</h5>
                        <h5 class="font-bold text-xs text-gray-700">Dependant: {{ patientInsurance.principalOfDependant }}</h5>
                    </td>
                    <td class="p-tiny w-1/3">
                        <h5 class="font-bold text-sm">Name: {{ patientInsurance.patientName }}</h5>
                        <h5 class="font-semibold text-xs text-gray-700">ID No: {{ patientInsurance.patientIDNo }}</h5>
                        <h5 class="font-semibold text-xs text-gray-700">Dependant No: {{ patientInsurance.dependantNo }}</h5>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
